// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*CONFDEV-25367: Insert files*/
/* always hide title of this button in comment */

.quick-comment-form #rte-toolbar .insert-files.toolbar-item {
	padding: 0 6px;
}

.quick-comment-form #rte-toolbar .insert-files .toolbar-trigger {
	margin: 0 -6px;
}

#rte-toolbar .insert-files.toolbar-item {
	padding: 0;
}

#rte-toolbar .insert-files .trigger-text {
	display: none;
}

#rte-toolbar .insert-files .aui-button {
	padding: 0 6px;
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/editor-plugins/insert-files/insert-files.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B,gDAAgD;;AAEhD;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf","sourcesContent":["/*CONFDEV-25367: Insert files*/\n/* always hide title of this button in comment */\n\n.quick-comment-form #rte-toolbar .insert-files.toolbar-item {\n\tpadding: 0 6px;\n}\n\n.quick-comment-form #rte-toolbar .insert-files .toolbar-trigger {\n\tmargin: 0 -6px;\n}\n\n#rte-toolbar .insert-files.toolbar-item {\n\tpadding: 0;\n}\n\n#rte-toolbar .insert-files .trigger-text {\n\tdisplay: none;\n}\n\n#rte-toolbar .insert-files .aui-button {\n\tpadding: 0 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
